module.exports = __webpack_public_path__ + "img/guanbi.1dc91f57.png";